<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import { goto } from "$app/navigation";
  import { parseUrl } from "$lib/utils/helpers.js";
  // import { openLink } from "./utils/helpers";

  // Get the block data
  export let blok;

  /**
   * TODO Remove when links are re-enabled after consumer tech page launch
   * Function to open an internal or external link
   * @param link - A link object
   */
  function openLink(link: any) {
    return false;

    const url = parseUrl(link);
    if (!url) return;

    // Open external URLs in a new tab, and internal URLs internally
    const isExternalUrl = link.linktype === "url";
    isExternalUrl ? window.open(url, "_blank") : goto(url);
  }
</script>

<section class="value-props-section section-header-width mx-auto" use:storyblokEditable={blok}>
  <h1 class="value-props-heading type:h2">{blok.heading}</h1>

  <!-- TODO Temporarily disabled
  <a href={parseUrl(blok.buttonLink)} class="value-props-button scale-up-on-hover"
    >{blok.buttonText}<span class="value-props-button-arrow">→</span></a
  > -->

  <div class="value-prop-items">
    {#each blok.valuePropositionItems as item}
      <div
        class="value-prop-item"
        style="background-image: url({item.backgroundImage.filename}/m/740x925)"
        on:click={() => openLink(item.link)}
        on:keydown={(e) => e.key === "Enter" && openLink(item.link)}
        role="button"
        tabindex="0"
      >
        <div class="value-prop-item-content">
          <h3 class="value-prop-item-heading type:h3">{item.heading}</h3>
          <p class="value-prop-item-subheading type:body-medium">{item.subheading}</p>
          <a href={parseUrl(item.link)} class="value-prop-item-link type:body-medium"
            >{item.linkText} →</a
          >
        </div>
      </div>
    {/each}
  </div>
</section>

<style lang="postcss">
  .value-props-section {
    margin-top: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
      text-align: center;
    }
  }

  .value-props-heading {
    margin-bottom: 2rem;

    @screen md {
      margin-bottom: 3.5rem; /* TODO Temporarily increased from 2rem */
    }
  }

  /* .value-props-button {
    display: inline-block;
    margin: 0 0 3rem 0;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    background-color: #365cd1;
    border-radius: 4px;
    text-decoration: none;

    &:hover {
      filter: brightness(120%);
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid rgb(var(--color-consumer-yellow));
      outline-offset: -3px;
    }

    @screen md {
      margin-bottom: 4rem;
    }
  }

  .value-props-button-arrow {
    margin-left: 1.5rem;
    font-weight: bold;
  } */

  .value-prop-items {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;

    @media (min-width: 1025px) {
      flex-direction: row;
      gap: 3.5rem;
    }
  }

  .value-prop-item {
    height: 70vh;
    max-height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    background-size: cover;
    border-radius: 4px;
    word-break: break-word;

    @media (min-width: 1025px) {
      width: 33%;
      max-height: 550px;
    }
  }

  .value-prop-item-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 2rem;
    border-radius: 4px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  }

  .value-prop-item-heading,
  .value-prop-item-subheading,
  .value-prop-item-link {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.7);
  }

  .value-prop-item-heading {
    font-size: 50px;
    color: #fff;
  }

  .value-prop-item-subheading {
    color: #fff;
  }

  .value-prop-item-link {
    display: none; /* TODO Temporarily disabled */
    margin-top: 1rem;
    font-weight: bold;
    color: #fff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
</style>
